export default __webpack_public_path__ + "static/media/SEI_Gameboard_FAQs.b82da326.pdf";